import { useGetDemoQuery, useGetRecordingQuery } from '@carboncopyco/data';

export function useShouldUpdateDemoFromRecording(
  demoId: string,
  workspaceId: string,
  organizationId: string
) {
  const { data: demo } = useGetDemoQuery({
    organizationId,
    workspaceId,
    id: String(demoId),
  });
  const { data: recording } = useGetRecordingQuery(
    { organizationId, id: String(demo?.recordId) },
    { skip: !demo, refetchOnMountOrArgChange: true }
  );
  return (
    recording &&
    demo &&
    !recording?.isDeleted &&
    demo?.recordRevisionId < recording?.revisionId
  );
}
